import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { SalesReturnData,SalesReturn } from '../../../interfaces/masters/sales_return';
import { SalesReturnApi } from '../api/salesreturn.api';

@Injectable() 
export class SalesReturnService extends SalesReturnData{
  
  constructor(private api: SalesReturnApi) {
    super();
  } 
  
  getall(url: string): Observable<SalesReturn[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<SalesReturn>{
      return this.api.getby_id(url);
  }

  create(url: string, data:SalesReturn): Observable<SalesReturn[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:SalesReturn): Observable<SalesReturn> { 
    return this.api.update(url,data);
  }  
  searchList(url: string,data:any): Observable<any> {
      
      return this.api.searchList(url,data);
    }
    distinctReason(url: string): Observable<any> {
    return this.api.distinctReason(url);
  }
      
    //Sales Report For MultiBranch
    searchForMultiBranch(url: string,data:any): Observable<any> {
      return this.api.searchList(url,data);
    }

}
